import type { EvView } from "./eventLoad";
// 英語の画面のときに、大会の英語の文（events.en）を重ねる。英語の値が無いところは日本語のまま残す（planning/2026-10-13-英語対応.md）
export interface EventEnDoc { contactName?: string; disciplines?: string[]; name?: string; description?: string; venue?: string; classNames?: Record<string, string>; extraFieldLabels?: Record<string, string>; extraFieldOptions?: Record<string, string[]>; waiverText?: string; waiverVersion?: string; galleryCaptions?: string[] }
export function applyEn(v: EvView, en: EventEnDoc | undefined): EvView {
  const x = en ?? {};
  return {
    ...v,
    name: x.name || v.name, description: x.description || v.description, venue: x.venue || v.venue,
    contact: v.contact && x.contactName ? { ...v.contact, name: x.contactName } : v.contact,
    disciplines: v.disciplines.map((d, i) => x.disciplines?.[i] || d),
    classes: v.classes.map((c) => ({ ...c, name: x.classNames?.[c.id] || c.name })),
    extraFields: v.extraFields.map((f) => ({ ...f, label: x.extraFieldLabels?.[f.key] || f.label,
      ...(f.options && x.extraFieldOptions?.[f.key] ? { optionLabels: f.options.map((o, i) => x.extraFieldOptions![f.key][i] || o) } : {}) })),
    gallery: v.gallery.map((g, i) => ({ ...g, caption: x.galleryCaptions?.[i] || g.caption })),
    waiver: !v.waiver ? null : x.waiverText && x.waiverVersion ? { text: x.waiverText, version: x.waiverVersion, lang: "en" } : { ...v.waiver, jaOnly: true },
  };
}
